import { AiOutlineCheckCircle } from 'react-icons/ai'

const ApprovedLabel = ({ message } : { message : string }) =>
  <div className='flex items-center gap-1 text-green-700'>
    <AiOutlineCheckCircle color='green' size={32}/>
    <h6>{message}</h6>
  </div>

export default ApprovedLabel